// Small perf helpers to keep the app light inside mobile in-app browsers (e.g. Slush webview),
// where continuous DOM animation and frequent re-renders from the live trade stream cause lag.

export const isTouch =
  typeof window !== "undefined" &&
  ((window.matchMedia && window.matchMedia("(pointer: coarse)").matches) || "ontouchstart" in window);

export const isHidden = () =>
  typeof document !== "undefined" && document.visibilityState === "hidden";

// How long to wait before acting on a burst of live trades. Mobile coalesces much harder so the
// board/chart refresh at most every few seconds instead of on every single trade.
export const liveDebounceMs = isTouch ? 5000 : 1200;


// Mount-gating media query: unlike CSS `hidden`, this keeps a component OUT of the React tree
// (and stops its effects running) when the query doesn't match.
import { useState, useEffect } from "react";
export function useMediaQuery(query) {
  const get = () => typeof window !== "undefined" && window.matchMedia(query).matches;
  const [matches, setMatches] = useState(get);
  useEffect(() => {
    const m = window.matchMedia(query);
    const on = () => setMatches(m.matches);
    on();
    m.addEventListener ? m.addEventListener("change", on) : m.addListener(on);
    return () => (m.removeEventListener ? m.removeEventListener("change", on) : m.removeListener(on));
  }, [query]);
  return matches;
}
